/**
 * Horizontal Service Flow Section - Simplified
 */
document.addEventListener('DOMContentLoaded', function() {
  initServiceFlow();
});

function initServiceFlow() {
  const sections = document.querySelectorAll('.h-service-flow');
  
  sections.forEach(section => {
    const sectionId = section.id.replace('h-section-', '');
    const track = document.getElementById(`cardsTrack-${sectionId}`);
    const cards = section.querySelectorAll('.h-flow-card');
    const progressDots = section.querySelectorAll('.h-progress-dot');
    const progressFill = section.querySelector('.h-progress-fill');
    const prevBtn = section.querySelector('.h-nav-prev');
    const nextBtn = section.querySelector('.h-nav-next');
    
    if (!cards.length) return;
    
    let currentIndex = 0;
    const totalSteps = cards.length;
    
    // Check if mobile
    function isMobile() {
      return window.innerWidth <= 768;
    }
    
    // Update desktop display only
    function updateDesktopDisplay() {
      if (isMobile()) return; // Don't do anything on mobile
      
      // Update track position
      const cardWidth = 100;
      const translateX = -currentIndex * cardWidth;
      track.style.transform = `translateX(${translateX}%)`;
      
      // Update card states
      cards.forEach((card, index) => {
        card.classList.toggle('active', index === currentIndex);
      });
      
      // Update progress dots
      progressDots.forEach((dot, index) => {
        dot.classList.remove('active', 'completed');
        
        if (index === currentIndex) {
          dot.classList.add('active');
        } else if (index < currentIndex) {
          dot.classList.add('completed');
        }
      });
      
      // Update progress bar
      const progressPercent = (currentIndex / (totalSteps - 1)) * 100;
      progressFill.style.width = `${progressPercent}%`;
      
      // Update navigation buttons
      if (prevBtn && nextBtn) {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === totalSteps - 1;
      }
    }
    
    // Navigate to specific step (desktop only)
    function goToStep(index) {
      if (index < 0 || index >= totalSteps || isMobile()) return;
      currentIndex = index;
      updateDesktopDisplay();
    }
    
    // Next step
    function nextStep() {
      if (currentIndex < totalSteps - 1) {
        goToStep(currentIndex + 1);
      }
    }
    
    // Previous step
    function prevStep() {
      if (currentIndex > 0) {
        goToStep(currentIndex - 1);
      }
    }
    
    // Desktop event listeners
    if (prevBtn && nextBtn) {
      prevBtn.addEventListener('click', prevStep);
      nextBtn.addEventListener('click', nextStep);
    }
    
    // Progress dot clicks (desktop only)
    progressDots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!isMobile()) {
          goToStep(index);
        }
      });
    });
    
    // Touch/swipe support for desktop
    let touchStartX = 0;
    let touchEndX = 0;
    
    if (track) {
      track.addEventListener('touchstart', (e) => {
        if (!isMobile()) {
          touchStartX = e.changedTouches[0].screenX;
        }
      }, { passive: true });
      
      track.addEventListener('touchend', (e) => {
        if (!isMobile()) {
          touchEndX = e.changedTouches[0].screenX;
          handleSwipe();
        }
      }, { passive: true });
    }
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextStep();
        } else {
          prevStep();
        }
      }
    }
    
    // Keyboard navigation (desktop only)
    section.addEventListener('keydown', (e) => {
      if (isMobile()) return;
      
      if (e.key === 'ArrowLeft') {
        prevStep();
      } else if (e.key === 'ArrowRight') {
        nextStep();
      } else if (e.key >= '1' && e.key <= '9') {
        const stepIndex = parseInt(e.key) - 1;
        if (stepIndex < totalSteps) {
          goToStep(stepIndex);
        }
      }
    });
    
    // Make section focusable for keyboard events
    section.setAttribute('tabindex', '0');
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (!isMobile()) {
          updateDesktopDisplay();
        }
      }, 250);
    });
    
    // Initial setup
    if (!isMobile()) {
      updateDesktopDisplay();
    }
  });
}

// Shopify theme editor support
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.classList.contains('h-service-flow')) {
      setTimeout(initServiceFlow, 100);
    }
  });
  
  document.addEventListener('shopify:block:select', function(event) {
    const block = event.target;
    const section = block.closest('.h-service-flow');
    if (section) {
      const stepIndex = parseInt(block.dataset.step);
      if (!isNaN(stepIndex) && window.innerWidth > 768) {
        const dots = section.querySelectorAll('.h-progress-dot');
        if (dots[stepIndex]) {
          dots[stepIndex].click();
        }
      }
    }
  });
}